import { useCallback, useContext } from 'react';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import { useGetVehicleId } from '~/context/vdp/VehicleContext';
import {
  type FavoritesArguments,
  useRemoveFavorite as useRemoveFavoriteCommon
} from '~/hooks/common/favorites';

export function useBeforeRemoveFavorite() {
  const { setFavorite } = useContext(UserVehicleContext);
  const currentVehicleId = useGetVehicleId();

  return useCallback(
    ({ vehicleId }: FavoritesArguments) => {
      if (currentVehicleId === vehicleId) {
        setFavorite(false);
      }
    },
    [currentVehicleId, setFavorite]
  );
}

export default function useRemoveFavorite() {
  const removeFavorite = useRemoveFavoriteCommon({
    beforeRemoveFavorite: useBeforeRemoveFavorite()
  });

  return useCallback(
    (args: FavoritesArguments) =>
      removeFavorite({ nativeEventSource: 'vdp', ...args }),
    [removeFavorite]
  );
}
